<app-grid>
    <app-cell mobile="full:full">
        <div *ngIf="showMap"
             class="maps-container"
        >
            <google-map *ngIf="options"
                        [options]="options"
                        [zoom]="options.zoom ? options.zoom : 8"
                        (mapDragend)="boundsChanged()"
                        (zoomChanged)="boundsChanged()"
                        width="100%"
                        height="100%"
            >
                <ng-container *ngIf="! groupedMarkers; else groupMarkers" [ngTemplateOutlet]="cluster"
                              [ngTemplateOutletContext]="{ markers: locationMarkers }">
                </ng-container>

                <ng-template #groupMarkers>
                    <ng-container [ngTemplateOutlet]="cluster"
                                  [ngTemplateOutletContext]="{ markers: groupedMarkers.dealer ?? [] }"
                    ></ng-container>
                    <ng-container [ngTemplateOutlet]="cluster"
                                  [ngTemplateOutletContext]="{ markers: groupedMarkers.webshop ?? [] }"
                    ></ng-container>
                    <ng-container [ngTemplateOutlet]="cluster"
                                  [ngTemplateOutletContext]="{ markers: groupedMarkers['dealer-shop'] ?? [] }"
                    ></ng-container>
                </ng-template>

                <ng-template #cluster let-markers="markers">
                    <map-marker-clusterer [gridSize]="50"
                                          [styles]="getMarkerClustererStyles(markers)"
                    >
                        <ng-container *ngFor="let marker of markers; trackBy: trackByFn">
                            <map-marker #mapMarker="mapMarker"
                                        [position]="{ lat: marker.lat, lng: marker.lng }"
                                        [options]="{ icon: '/assets/images/map-markers/'+marker.icon+'-pin.svg' }"
                                        (mapClick)="markerClick(mapMarker, marker, $any(infoWindow))"
                            ></map-marker>
                        </ng-container>
                    </map-marker-clusterer
                    >
                </ng-template>

                <map-marker *ngIf="userMarker"
                            [position]="{ lat: userMarker.position.lat, lng: userMarker.position.lng }"
                            [icon]="'/assets/images/map-markers/current-location-pin.svg'"
                ></map-marker>

                <map-info-window #infoWindow="mapInfoWindow">
                    <ng-container *ngIf="selectedMarker">
                        <div class="marker-info">
                            <img src="/assets/images/map-markers/{{selectedMarker.icon}}-pin.svg"
                                 loading="lazy"
                                 [alt]="'De Eekhoorn ' + selectedMarker.icon"
                            />

                            <div class="text-content">
                                <div class="mb">
                                    <label class="bold">
                                        {{ selectedMarker.name }}
                                    </label>
                                </div>

                                <p class="small mb">
                                    {{selectedMarker.street}}, {{selectedMarker.postalCode}} {{selectedMarker.city}}
                                </p>

                                <label class="small small-margin mb">
                                    <app-button *ngIf="selectedMarker.website && selectedMarker.website !== ''"
                                                theme="link"
                                                type="link"
                                                [href]="selectedMarker.website | safe: 'url'"
                                                [cmsTarget]="LinkTargetEnum.Blank"
                                    >
                                        {{ selectedMarker.website }}
                                    </app-button>
                                </label>
                            </div>
                        </div>

                        <div class="logo-container">
                            <ng-container *ngFor="let brand of selectedMarker.brands">
                                <div class="logo"
                                     [ngStyle]="{'background-image': 'url(\'/assets/images/map-markers/'+brand+'-logo.svg'}"
                                ></div>
                            </ng-container>
                        </div>
                    </ng-container>
                </map-info-window>
            </google-map>

            <div *ngIf="showFilter"
                 class="dealer-filter"
            >
                <div class="filter-container">
                    <div class="filters">
                        <h1 class="small">
                            {{ 'dealers.dealers' | translate }}
                        </h1>

                        <form class="mt" [formGroup]="searchForm">
                            <div class="input-wrapper">
                                <span class="search-icon icon icon-search ng-star-inserted"></span>

                                <input ngx-gp-autocomplete
                                       (onAddressChange)="handleAddressChange($event)"
                                       formControlName="searchControl"
                                       [placeholder]="'dealers.search-by' | translate"
                                />
                            </div>
                        </form>

                        <div class="mt buttons">
                            <app-button theme="line"
                                        size="smaller"
                                        layout="icon-label"
                                        icon="current-location"
                                        [state]="locationState"
                                        (clicked)="currentLocation()"
                            >
                                {{ 'dealers.current-location' | translate }}
                            </app-button>

                            <app-button theme="line"
                                        size="smaller"
                                        layout="icon-label"
                                        icon="filter"
                                        (clicked)="openFilterDialog()"
                            >
                                <div class="filter-button">
                                    {{ 'dealers.filters' | translate }}
                                    <div class="amount">
                                        <label class="text-white small">
                                            {{ filterCount }}
                                        </label>
                                    </div>
                                </div>
                            </app-button>
                        </div>
                    </div>

                    <div class="dealer-list">
                        <div *ngFor="let dealer of locationMarkers"
                             (click)="setFocus(dealer)"
                             [id]="dealer.objectID"
                             class="dealer-card"
                             [class.selected-marker]="dealer.objectID === selectedMarker?.objectID"
                        >
                            <div class="dealer-icon {{dealer.icon}}">
                                <span [appIcon]="dealer.icon" class="icon"></span>
                            </div>

                            <div class="text">
                                <h3 class="subheading">
                                    {{ dealer.name }}
                                </h3>

                                <p class="small">
                                    <span class="first-letter-uppercase">{{ dealer.street }}</span>,
                                    <span class="add-spacing">{{ dealer.postalCode }}</span>
                                    <span class="first-letter-uppercase">{{ dealer.city }}</span>
                                </p>

                                <div class="brands">
                                    <ng-container *ngFor="let brand of dealer.brands">
                                        <div class="brand-badge">
                                            <label class="white-bold stretch">
                                                {{ brand }}
                                            </label>
                                        </div>
                                    </ng-container>
                                </div>

                                <app-button *ngIf="dealer.website !== ''"
                                            theme="link"
                                            layout="label-icon"
                                            icon="arrow-right"
                                            type="link"
                                            [href]="dealer.website | safe: 'url'"
                                            [cmsTarget]="LinkTargetEnum.Blank"
                                >
                                    {{ 'register.website' | translate }}
                                </app-button>
                            </div>
                        </div>

                        <div *ngIf="! locationMarkers.length"
                             class="no-results"
                        >
                            {{ 'dealers.no-dealers-found' | translate }}
                        </div>
                    </div>

                    <div *ngIf="locationMarkers.length" class="gradient-div"></div>
                </div>
            </div>
        </div>
    </app-cell>
</app-grid>
